// ------------ import external dependencies ------------
import { useFormik } from "formik";
import React, { useState } from "react";
// ----------- import internal dependencies -----------
import FormInput from "../../../../../components/Forms/input/FormInput";
import Button from "../../../../../components/Button";
import { validatePersonalData } from "../../../../../utils/validators";
import { useStoreWrapper } from "../../../../../store/store";
import { UserCreation } from "../../type";
import { Form } from "./PersonalData.styles";
import {
  ContactContainer,
  Label,
  LoadingIcon,
  UserNameContainer,
  UserNameInput,
  UserNameMainContainer,
} from "../Roles/style";

import { ErrorMessage } from "../../../../../components/Forms/input/input.style";
import CustomLoader from "../../../../../components/CustomLoader";
import useVerifyUserName from "./hooks/useVerifyUserName";
import useGetAccountPrefix from "./hooks/useGetAccountPrefix";

function PersonalData({ cb, editUserData }: UserCreation) {
  // ------- intialize custom hooks -----
  const updatePersonalData = useStoreWrapper(
    (state) => state.updatePersonalData
  );
  const title = useStoreWrapper((state) => state.title);
  const firstName = useStoreWrapper((state) => state.firstName);
  const lastName = useStoreWrapper((state) => state.lastName);
  const userName = useStoreWrapper((state) => state.userName);

  /**
   * Form validation config
   */

  const formik = useFormik({
    initialValues: {
      title: title,
      firstName: firstName,
      lastName: lastName,
      userName: userName,
    },
    validationSchema: validatePersonalData(),
    onSubmit: async (values: any) => {
      updatePersonalData({ ...values });
      cb({ ...values });
    },
  });

  const [generatedUserName, setGeneratedUserName] = useState("");

  // get account prefix

  const userAccountPrefix = useGetAccountPrefix();

  let userNameErrors;

  if (formik.touched.userName && formik.errors.userName) {
    userNameErrors = formik.errors.userName;
  }

  const { errorMessage, isCheckingAvailability, isAvailable } =
    useVerifyUserName(generatedUserName);

  const generateUserName = (first: string, last: string) => {
    const firstLetter = first.charAt(0);
    // remove spaces from last name
    last = last.replace(/\s/g, "");
    let userName = `${firstLetter}${last}`;
    return userName;
  };

  const handleCreateUserName = (e: any) => {
    let firstName = formik.values.firstName;
    let lastName = e.target.value;
    // create user name
    let genUserName = generateUserName(firstName, lastName);
    setGeneratedUserName(genUserName);
    formik.setFieldValue("userName", genUserName);
  };
  const handleEditUserName = (e: any) => {
    e.preventDefault();
    setGeneratedUserName(e.target.value);
  };

  return (
    <div>
      <Form onSubmit={formik.handleSubmit}>
        <FormInput
          data-testid="input-title"
          label="Job Title"
          name="title"
          placeholder="Title"
          variant="sm"
          onChange={formik.handleChange}
          value={formik.values.title}
          onBlur={formik.handleBlur}
        />
        <FormInput
          data-testid="input-first-name"
          label="First name"
          name="firstName"
          placeholder="First Name"
          variant="sm"
          value={formik.values.firstName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          // @ts-ignore
          errorMessage={
            formik.touched.firstName && formik.errors.firstName
              ? formik.errors.firstName
              : null
          }
        />
        <FormInput
          label="Last name"
          name="lastName"
          placeholder="Last Name"
          variant="sm"
          value={formik.values.lastName}
          onChange={(e) => {
            formik.handleChange(e);
            handleCreateUserName(e);
          }}
          onBlur={formik.handleBlur}
          // @ts-ignore
          errorMessage={
            formik.touched.lastName && formik.errors.lastName
              ? formik.errors.lastName
              : null
          }
        />
        {/* ------- user name ------- */}
        {userAccountPrefix === "N/A" ? null : (
          <UserNameMainContainer>
            <Label htmlFor="userName">User name</Label>

            <UserNameContainer>
              <ContactContainer>
                {`${userAccountPrefix}` || "doe"}.
              </ContactContainer>
              <UserNameInput
                data-testid="input-user-name"
                isAvailable={errorMessage === ""}
                autoComplete="off"
                onCopyCapture={(e) => e.preventDefault()}
                onCopy={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                name="userName"
                placeholder="username"
                value={formik.values.userName}
                onChange={(e) => {
                  formik.handleChange(e);
                  handleEditUserName(e);
                }}
                onBlur={formik.handleBlur}
                // @ts-ignore
                disabled={
                  formik.values.firstName === "" ||
                  formik.values.lastName === ""
                }
                // @ts-ignore
                errorMessage={
                  formik.touched.userName && formik.errors.userName
                    ? formik.errors.userName
                    : null
                }
              />
              {isCheckingAvailability && (
                <LoadingIcon>
                  <CustomLoader></CustomLoader>
                </LoadingIcon>
              )}
            </UserNameContainer>
            {
              // @ts-ignore
              userNameErrors && <ErrorMessage>{userNameErrors}</ErrorMessage>
            }
            {errorMessage !== "" ? (
              <ErrorMessage>{errorMessage}</ErrorMessage>
            ) : null}
          </UserNameMainContainer>
        )}
        {/* ------- action buttons ------- */}
        <div className="mt-10 flex items-center justify-end gap-3">
          {/* {errorMessage === "" ? ( */}
          {userAccountPrefix === "N/A" ? null : (
            <Button
              data-testid="continue-button"
              variant="md"
              type="submit"
              textContent="Continue"
              addClass="bg-purple-main ml-auto block text-lg text-white-main px-8"
              // @ts-ignore
              disabled={
                !(
                  formik.values.firstName &&
                  formik.values.firstName.length > 2 &&
                  formik.values.lastName &&
                  formik.values.lastName.length > 2 &&
                  formik.values.userName &&
                  formik.values.userName.length > 2
                ) ||
                userNameErrors ||
                errorMessage !== "" ||
                !userAccountPrefix ||
                isCheckingAvailability ||
                !isAvailable
              }
            />
          )}
          {/* // ) : null} */}
        </div>
      </Form>
    </div>
  );
}

export default PersonalData;
